import React from "react";
import { formatNumberForDisplay } from "../../utils/numberFormat";

/**
 * FormattedAmount - Component to display formatted amounts
 * Usage: <FormattedAmount value={1000000} /> => "1,000,000.00"
 */
const FormattedAmount = ({
  value,
  decimals = 2,
  prefix = "",
  suffix = "",
  className = "",
  ...props
}) => {
  const formatted = formatNumberForDisplay(value, decimals);

  if (!formatted) {
    return null;
  }

  return (
    <span className={className} {...props}>
      {prefix}
      {formatted}
      {suffix && (
        <span style={{ marginInlineStart: 4, fontSize: "0.9em" }}>
          {suffix}
        </span>
      )}
    </span>
  );
};

export default FormattedAmount;
